var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// /Users/KCrisanto/Documents/dea-spms/node_modules/lodash/_nativeCreate.js
// module id = 35
// module chunks = 0